<template>
  <li class="timeline-item ">
    <div class="timeline-badge ">
      <icon  name="back" class="h-6 mb-2 inline fill-white"></icon>
    </div>
    <div class="timeline-panel ">

      <div class="timeline-heading">
        <h4 class="timeline-title">
          <span class="mx-0.5 px-2 py-1 rounded-md text-white bg-gray-600">
          Kthyer nga shoferi shpërndarës
        </span>
        </h4>
        <div class="timeline-panel-controls">
          <div class="timestamp">
<!--            <button v-if="user.role === 'admin' || user.role === 'superadmin'" @click="showDateModal = true"><small >{{ item.hr_created_at }}</small></button>-->

            <small >{{ item.hr_created_at }}</small>

            <br>
            <small >{{ item.user }}</small>
          </div>
        </div>
      </div>

      <div class="timeline-body mt-5">{{ item.description }}</div>
      <div v-if="item.comment" class="timeline-body">Koment: {{item.comment}}</div>
      <div v-if="item.document_path" class="timeline-body">Dëshmi: <a class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('files.download', {path: item.document_path})" download>Shkarko</a></div>

    </div>
  </li>
</template>

<script>
import FileOutput from '@/Shared/FileOutput'
import Icon from '@/Shared/Icon'
import {computed} from 'vue'
import {usePage} from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'OrderReturnTimelineItem',
  components: {
    FileOutput,
    Icon,
    Modal,
    LoadingButton
  },
  props: {
    item: Object,
    statusColor: String
  },
  mounted() {
    const statusDate = document.getElementById('statusDate')
  },
  data() {
    return {
      form: this.$inertia.form({
        status_date:  this.formatDate(this.item.hr_created_at)
        // status_date: null
      }),
      showDateModal: false,
      statusRegistered: this.item.status_id === 1,
      statusSuccess: this.item.status_id === 5,
      statusCancellation: this.item.status_id === 7,
    }
  },
  methods: {
    updateStatusDate(){
      this.form.put(route('admin.orders.update.status-date',{orderStatusLog: this.item.id ,status_date: this.form.status_date}))
      this.showDateModal = false;
    },
    formatDate(statusDate){
      let date = new Date(this.item.hr_created_at)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US',{hour12: false})
    }
  },
  // computed: {
  //   iconName(){
  //     let iconName = 'progress'
  //     if(this.item.status_id === 1)
  //       iconName = 'registered'
  //
  //     if(this.item.status_id === 3)
  //       iconName = 'warehouse'
  //
  //     if(this.item.status_id === 4)
  //       iconName = 'shipping'
  //
  //     if(this.item.status_id === 5)
  //       iconName = 'tick'
  //
  //     if(this.item.status_id === 6)
  //       iconName = 'pending'
  //
  //     if(this.item.status_id === 7)
  //       iconName = 'cross'
  //
  //     if(this.item.status_id === 8)
  //       iconName = 'returned'
  //
  //     if(this.item.status_id === 9)
  //       iconName = 'merged'
  //
  //     return iconName
  //   },
  //   itemStatusColor(){
  //     let statusColor = 'bg-indigo-500'
  //     if(this.item.status_id === 1)
  //       statusColor = 'bg-yellow-500'
  //
  //     if(this.item.status_id === 3)
  //       statusColor = 'bg-orange-500'
  //
  //     if(this.item.status_id === 4)
  //       statusColor = 'bg-indigo-900'
  //
  //     if(this.item.status_id === 5)
  //       statusColor = 'bg-green-500'
  //
  //     if(this.item.status_id === 6)
  //       statusColor = 'bg-yellow-700'
  //
  //     if(this.item.status_id === 7)
  //       statusColor = 'bg-red-500'
  //
  //     if(this.item.status_id === 8)
  //       statusColor = 'bg-gray-400'
  //
  //     if(this.item.status_id === 9)
  //       statusColor = 'bg-green-500'
  //
  //     return statusColor
  //   }
  // },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
